import { FormField, FormItem, FormLabel } from '@/components/ui/form';
import RepetitionInterval from '@/domain/termine/components/RepetitionInterval/RepetitionInterval';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/DatePickerFormField';
import { DatePickerDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/DatePickerDrawer';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TerminWiederholung } from '@/domain/termine/shared/types';
import { useTranslation } from 'react-i18next';
import { DatePickerSheet } from '@/domain/termine/features/CreateTermin/Sheet/components/ DatePickerSheet';
import { RepetitionIntervalDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/RepetitionIntervalDrawer';

export function RepetitionIntervalFormField() {
  const { t } = useTranslation();
  const { isMobile, form } = useCreateTermineFormContext();
  const wiederholung = form.watch('wiederholung');

  return (
    <div className="flex flex-col gap-4 w-full">
      <FormField
        control={form.control}
        name="wiederholung"
        render={({ field }) => (
          <FormItem className="flex flex-col w-full gap-1">
            <FormLabel>{t('domain.termine.repeat')}</FormLabel>
            {isMobile ? (
              <RepetitionIntervalDrawer
                value={field.value}
                onChange={field.onChange}
              />
            ) : (
              <RepetitionInterval
                value={field.value}
                onChange={field.onChange}
              />
            )}
          </FormItem>
        )}
      />
      {wiederholung !== TerminWiederholung.OHNE && (
        <DatePickerFormField name="wiederholungBis">
          {({ value, onChange, label }) =>
            isMobile ? (
              <DatePickerDrawer
                value={value}
                onChange={onChange}
                label={label}
                placeholder={t('domain.termine.form.fields.auswaehlen')}
                className="text-neutrals-400"
              />
            ) : (
              <DatePickerSheet
                value={value}
                onChange={onChange}
                label={label}
              />
            )
          }
        </DatePickerFormField>
      )}
    </div>
  );
}
